import * as React from 'react';
import { GlobalPrivateState } from 'src/api';
import { connect } from 'react-redux';
import { ConfigurationModel } from 'franke-trough-dependencies';
import { FormattedMessage } from 'react-intl';
import MESSAGES from './checkout.messages';

export interface  GeneralInformationCheckoutProps {
  configuration: GlobalPrivateState['configuration'];
}

export class GeneralInformationCheckout extends React.Component<GeneralInformationCheckoutProps, any> {
  public render() {
    return (
      <div className="general-information-partial">
        <span className="configuration-name">
          <FormattedMessage {...MESSAGES.generalInfoHeadline} />
        </span>
        <ul>
          {this.configuration && (
            <>
            <li>
              <FormattedMessage {...MESSAGES.generalInfoConfName} /> {this.configuration.name}</li>
            </>
          )}
        </ul>
      </div>
    );
  }
  private get configuration(): ConfigurationModel | undefined {
    const { configuration } = this.props;
    return configuration && configuration.result;
  }
}

export const GeneralInformationCheckoutComponent = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
}))(GeneralInformationCheckout);

export default GeneralInformationCheckoutComponent;